import type { ReactNode } from 'react';
import { B2BLandingHeader } from '@modules/public/landing/B2BLandingHeader';
import { B2BFooter } from '@modules/public/landing/B2BTestimonialsAndCTA';

type Props = {
  children: ReactNode;
  hideDemoButton?: boolean;
};

/**
 * Shared shell for all B2B marketing / footer-link pages.
 *
 * Light mode background: a clearly visible but non-distracting lavender-to-white
 * diagonal gradient — #EEF0FF → #F8F8FF → #F5F6FF → #EBF0FF.
 * Dark mode: solid zinc-950.
 */
export function B2BMarketingPageLayout({ children, hideDemoButton }: Props) {
  return (
    <div
      className={[
        'min-h-screen flex flex-col text-gray-900 transition-colors duration-300',
        'dark:text-zinc-100 dark:[background:#09090b]',
        // Light-mode diagonal lavender gradient — Tailwind arbitrary property
        '[background:linear-gradient(160deg,#EEF0FF_0%,#F8F8FF_38%,#F5F6FF_65%,#EBF0FF_100%)]',
      ].join(' ')}
    >
      <B2BLandingHeader forceSolid hideDemoButton={hideDemoButton} />
      <div className="h-[75px] shrink-0" aria-hidden />
      <div className="flex-1 w-full min-w-0">{children}</div>
      <B2BFooter />
    </div>
  );
}
